<div style="display: flex; flex-direction: column; flex: 1;min-width: 320px;">
    <div class="header-color" style="display: flex; flex-direction: row;">
        <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;" translate>
            Calendar
        </div>
        <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center;flex-grow:unset;">
            <button mat-stroked-button class="mat-card-button" (click)="goToCalendarClick()"><span translate>Go To Calendar</span></button>
        </div>
    </div>
    <!--Content-->
    <div style="display: flex; flex-direction: column; flex: 1;">
        <div class="date-header">{{selectedDate}}</div>
        <mat-divider></mat-divider>
        <div style="display: flex; flex-direction: row; flex: 1">
            <mat-list style="display: flex;flex-direction: column;flex: 1;" role="list">
                <mat-list-item style="display: flex;height: 100%;flex-direction: column;padding-top: 5px;" role="listitem" *ngFor="let event of events">
                    <div style="display: flex; flex-direction: column; flex: 1;padding-bottom: 10px;">
                        <div style="display: flex; flex: 1;" translate>{{event.EventTitle}}</div>
                        <div>
                            <div *ngIf="multiDayEvent(event)" style="display: flex; flex-direction: row; flex: 1; font-size: 9pt; padding-top: 3px">
                                {{getDateRangeString(event)}}
                            </div>
                            <div *ngIf="hasTimeLocation(event)" style="display: flex; flex-direction: row; flex: 1; font-size: 9pt">
                                {{getTimeLocationString(event)}}
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
    <div style="display: flex; flex-direction: row; padding: 5px">
        <div style="display: flex; flex-direction: column; align-items: flex-end; flex: 1; margin-left: 10px">
            <button mat-stroked-button class="mat-card-close-button" (click)="closeClick()">Close</button>
        </div>
    </div>
</div>
